<template>
  <div class="card card-margin">
    <MbreakdownReport />
    <m-two-dimensional />
    <b-container>
      <b-row v-if="!isUi2">
        <b-col>
          <h3 class="list-name-container">Target Audience</h3>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <m-slide-item :items="demos" :canDelete="false" />
          <div v-if="hasPhoneOption" class="phone-box">
            <h5>Phone Option: 
            {{ currentPhoneOption.desc }}</h5>
          </div>
          <div v-if="hasEmailOption" class="phone-box">
            <h5>Email Option: {{ emailOption }}</h5>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import MbreakdownReport from "@/components/summary/MbreakdownReport";
import MTwoDimensional from "@/components/summary/MTwoDimensional";
import MSlideItem from "@/components/slide/MSlideItem.vue";

export default {
  components: {
    MbreakdownReport,
    MSlideItem,
    MTwoDimensional,
  },
  props: {
    isUi2: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    selectedDemos() {
      return this.$store.getters["order/demoItems"];
    },
    isAllHoseholds() {
      return this.$store.getters["order/isAllHoseholds"];
    },
    hasPhoneOption() {
      return !this.$store.getters["demo/noPhoneOption"];
    },
    demos() {
      return this.$store.getters["order/demos"];
    },
    currentPhoneOption() {
      return this.$store.getters["order/currentPhoneOption"];
    },
    hasEmailOption() {
      return (
        this.$store.state.order.ListType === 260 &&
        this.$store.state.order.EmailOption !== ""
      );
    },
    emailOption() {
      var result = "I don't need business email addresses.";
      if (this.$store.state.order.EmailOption === "onlyemail") {
        result = "I'll take only those records with a business email address.";
      }
      if (this.$store.state.order.EmailOption === "email") {
        result = "I'll take those with and without business email addresses.";
      }
      return result;
    },
  },
  methods: {
    goDemo() {
      this.$router.push({ name: "demo" });
    },
    showBreakdown() {
      this.$root.$emit("bv::show::modal", "breakdownReport");
    },
    showTwoDimensional() {
      this.$root.$emit("bv::show::modal", "twoDimensional");
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  display: flex;
  justify-content: space-between;
}
.phone-box {
  margin-bottom: 16px;
}
.link {
  margin-left: 15px;
}
.other-option {
  margin-top: 8px;
  margin-bottom: 16px;
}
.card-margin {
  margin: 8px auto;
}
.list-name-container {
  margin-top: 16px;
  margin-left: 10px;
  font-weight: bold;
}
.right-title{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MTargetAudience.vue